export const questionsArray = [
  {
    id: 0,
    version: "long",
    level: 0,
    title: "Automation of Processes",
    question:
      "Which of the following best describes the automation level of your key processes (e.g., production, customer service, HR)?",
    options: [
      "Custom",
      "Fully automated with minimal manual intervention",
      "Mostly automated, with some manual checks",
      "Partially automated, requiring significant manual work",
      "Not automated; processes are manual",
    ],
  },
  {
    id: 1,
    version: "long",
    level: 0,
    question:
      "Which of the following business functions are well-automated in your organization?",
    options: [
      "Custom",
      "Production/Manufacturing",
      "Customer Service",
      "Human Resources (e.g. payroll onboarding)",
      "Sales & Marketing",
      "Finance & Accounting",
      "Supply Chain & Inventory Management",
      "IT Support & Maintenance",
    ],
  },
  {
    id: 2,
    version: "long",
    level: 0,
    question:
      "Which business functions would you like to see further automated in your organization?",
    options: [
      "Custom",
      "Production/Manufacturing",
      "Customer Service",
      "Human Resources (e.g. payroll onboarding)",
      "Sales & Marketing",
      "Finance & Accounting",
      "Supply Chain & Inventory Management",
      "IT Support & Maintenance",
    ],
  },
  {
    id: 3,
    version: "long",
    level: 0,
    question:
      "How often does your company evaluate processes for automation opportunities?",
    options: [
      "Custom",
      "Quarterly",
      "Annually",
      "Only when challenges arise",
      "We don’t actively evaluate this",
    ],
  },
  {
    id: 4,
    version: "long",
    level: 1,
    title: "Data Integration & Analytics",
    question:
      "How integrated are your data systems (e.g., CRM, ERP, Finance) across departments?",
    options: [
      "Custom",
      "Completely integrated, with real-time data sharing",
      "Mostly integrated, with regular data sync",
      "Partially integrated, with occasional manual data updates",
      "Not integrated; data is siloed",
    ],
  },
  {
    id: 5,
    version: "long",
    level: 1,
    question:
      "To what extent does your company use data analytics for decision-making?",
    options: [
      "Custom",
      "Advanced analytics (predictive, prescriptive)",
      "Basic analytics (dashboards, historical reporting)",
      "Limited analytics; data is reviewed occasionally",
      "Data analytics is not part of our decision-making",
    ],
  },
  {
    id: 6,
    version: "long",
    level: 2,
    title: "IT Infrastructure & Security",
    question:
      "How up-to-date is your IT infrastructure (e.g., servers, cloud services)?",
    options: [
      "Custom",
      "Fully modern and scalable, using the latest technology",
      "Recently updated but may require improvements",
      "In need of a major upgrade",
      "Outdated and rarely upgraded",
    ],
  },
  {
    id: 7,
    version: "long",
    level: 2,
    question:
      "What level of security measures are in place for your digital systems?",
    options: [
      "Custom",
      "Comprehensive cybersecurity program (firewalls, threat monitoring, regular audits)",
      "Basic security measures (firewalls, antivirus)",
      "Minimal security measures; not regularly monitored",
      "Security is not a major focus",
    ],
  },
  {
    id: 8,
    version: "long",
    level: 3,
    title: "Adoption of Emerging Technology",
    question:
      "How frequently does your company adopt new technologies to improve efficiency?",
    options: [
      "Custom",
      "Continuously; we actively seek new technologies",
      "Occasionally, when we identify a specific need",
      "Rarely; we use established methods and tools",
      "Not at all; we resist major changes",
    ],
  },
  {
    id: 9,
    version: "long",
    level: 3,
    question:
      "Which of these technologies are currently part of your operations?",
    options: [
      "Custom",
      "Artificial intelligence or machine learning",
      "IoT (Internet of Things) devices or systems",
      "Cloud computing solutions",
    ],
  },
  {
    id: 10,
    version: "long",
    level: 4,
    title: "Innovation Culture and Leadership",
    question:
      "How would you describe the leadership's approach to digital transformation?",
    options: [
      "Custom",
      "Proactive and heavily invested in digital transformation",
      "Open to digital change, with occasional investments",
      "Cautiously optimistic but slow to invest",
      "Resistant to digital transformation",
    ],
  },
  {
    id: 11,
    version: "long",
    level: 4,
    question:
      "How often does your team receive training in digital tools and practices?",
    options: [
      "Custom",
      "Regularly, with up-to-date training sessions",
      "Occasionally, but not consistently",
      "Rarely; we don’t prioritize digital training",
      "Never; no formal digital training provided",
    ],
  },
  {
    id: 12,
    version: "long",
    level: 5,
    title: "Customer Experience and Engagement",
    question:
      "How integrated is digital technology in your customer interactions?",
    options: [
      "Custom",
      "Completely digitalized (e.g., automated customer service, CRM integration)",
      "Mostly digital, with some manual support",
      "Partially digital, with a strong reliance on manual support",
      "Not digitalized; all customer interactions are manual",
    ],
  },
  {
    id: 13,
    version: "long",
    level: 5,
    question:
      "Does your company actively gather customer feedback to guide digital improvements?",
    options: [
      "Custom",
      "Yes, regularly through surveys, analytics, and direct feedback",
      "Occasionally, with limited feedback channels",
      "Rarely; we focus on internal insights",
      "No, we don’t gather customer feedback",
    ],
  },
  {
    id: 14,
    version: "long",
    level: 6,
    title: "Overall Digital Transformation Strategy",
    question:
      "Does your company have a documented digital transformation roadmap?",
    options: [
      "Custom",
      "Yes, with clear goals, timelines, and metrics",
      "Yes, but it’s only partially implemented",
      "No, but we are developing one",
      "No, we don’t have a digital transformation strategy",
    ],
  },
  {
    id: 15,
    version: "long",
    level: 6,
    question:
      "How does your company measure success in digitalization efforts?",
    options: [
      "Custom",
      "By defined KPIs and frequent performance reviews",
      "By general business outcomes but not specific KPIs",
      "No formal measurement; it’s based on perceived success",
      "We don’t measure success in digitalization",
    ],
  },
  {
    id: 16,
    version: "long",
    level: 7,
    title: "Results",
    question: "E-mail Address:",
    options: [],
    type: "input",
  },
  {
    id: 17,
    version: "short",
    level: 0,
    title: "Automation of Processes",
    question:
      "How automated are your company’s primary business processes (e.g., production, customer service, HR)?",
    options: [
      "Custom",
      "Fully automated with minimal manual intervention",
      "Mostly automated, with some manual checks",
      "Partially automated, requiring significant manual work",
      "Not automated; processes are mostly manual",
    ],
  },
  {
    id: 18,
    version: "short",
    level: 1,
    title: "Data Integration & Analytics",
    question:
      "How integrated are your company’s data systems (e.g., CRM, ERP, Finance), and to what extent is data analytics used in decision-making?",
    options: [
      "Custom",
      "Completely integrated, with advanced analytics guiding decisions",
      "Mostly integrated, using basic analytics for decision-making",
      "Partially integrated, with limited analytics use",
      "Data is siloed, and analytics are rarely used in decision-making",
    ],
  },
  {
    id: 19,
    version: "short",
    level: 2,
    title: "IT Infrastructure & Security",
    question:
      "How modern is your IT infrastructure, and what level of cybersecurity measures are in place?",
    options: [
      "Custom",
      "Fully up-to-date, with comprehensive cybersecurity measures",
      "Mostly modern, with basic cybersecurity measures",
      "Infrastructure is outdated but has minimal cybersecurity",
      "Infrastructure is outdated, with limited or no cybersecurity",
    ],
  },
  {
    id: 20,
    version: "short",
    level: 3,
    title: "Leadership's Approach to Digital Transformation",
    question:
      "How would you describe your leadership's approach to digital transformation and innovation?",
    options: [
      "Custom",
      "Proactive, heavily invested in digital initiatives",
      "Open to digital changes, with occasional investments",
      "Cautiously optimistic but slow to invest",
      "Resistant to digital transformation",
    ],
  },
  {
    id: 21,
    version: "short",
    level: 4,
    title: "Customer Experience and Digital Engagement",
    question:
      "To what extent is digital technology integrated into your customer interactions (e.g., automated support, CRM integration)?",
    options: [
      "Custom",
      "Fully digitalized, with customer interactions mostly automated",
      "Mostly digital, with some manual support",
      "Partially digital, with significant reliance on manual processes",
      "Not digitalized; interactions are primarily manual",
    ],
  },
  {
    id: 22,
    version: "short",
    level: 5,
    title: "Results",
    question: "E-mail Address:",
    options: [],
    type: "input",
  },
];
